import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { file_path } from "./environment";
import axios from "axios";

function Feedback({ item }) {
    return (
        <div className="feedback-item">
            <h4>{item.title}</h4>
            {item.content?.map((content, index) => (
                <div key={index} dangerouslySetInnerHTML={{ __html: content }} />
            ))}
        </div>
    );
}

function getLatestYear(history) {
    const years = Object.keys(history || {}).sort((yearA, yearB) => Number(yearB) - Number(yearA));
    return years[0] || null;
}

function History({ history }) {
    if (!history) {
        return null;
    }

    return (
        <div className="firm-history-list">
            {Object.entries(history)
                .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
                .map(([year, data]) => (
                <section key={year} className="firm-year-card">
                    <div className="firm-year-header">
                        <h3>{year}</h3>
                        <span>{data.ranking}</span>
                    </div>
                    <div className="firm-year-body">
                        {data.feedback.map((feedback) => {
                            return <Feedback key={feedback.title} item={feedback} />;
                        })}
                    </div>
                </section>
            ))}
        </div>
    );
}

function Subsection({ subsection }) {
    const latestYear = getLatestYear(subsection.history);

    return (
        <section className="firm-section-card">
            <div className="firm-section-header">
                <div>
                    <p className="firm-section-kicker">{subsection.guide} Guide</p>
                    <h2>{subsection.practice}</h2>
                    <p className="firm-section-location">{subsection.location}</p>
                </div>
                <div className="firm-section-meta">
                    <div>
                        <span className="firm-meta-label">Years ranked</span>
                        <span className="firm-meta-value">{subsection.yearsRanked}</span>
                    </div>
                    {latestYear ? (
                        <div>
                            <span className="firm-meta-label">Latest year</span>
                            <span className="firm-meta-value">{latestYear}</span>
                        </div>
                    ) : null}
                </div>
            </div>
            <History history={subsection.history} />
        </section>
    );
}

function Content({ subsections }) {
    if (!subsections) {
        return null;
    }

    return (
        <div>
            {Object.entries(subsections).map(([id, subsection]) => (
                <Subsection key={id} subsection={subsection} />
            ))}
        </div>
    );
}

export default function EditorialLawyers() {
    const [lawyer, setLawyer] = useState({});
    const { lawyerId } = useParams();

    const sectionCount = Object.keys(lawyer.subsections || {}).length;

    useEffect(() => {
        axios.get(file_path(`/lawyer-page/${lawyerId}.json`)).then((res) => {
            setLawyer(res.data);
            document.title = `${res.data.name} - ${res.data.firm}`;
        });
    }, [lawyerId]);

    return (
        <main className="firm-editorial-page">
            <section className="hero lawyer-hero">
                <h1>{lawyer.name}</h1>
                <div className="firm-hero__stats">
                    <div className="firm-hero__stat">
                        <span className="firm-meta-label">Firm</span>
                        <span className="firm-meta-value">
                            <Link to={`/editorial/firms/${lawyer.firm_id}`} role="button">{lawyer.firm}</Link>
                        </span>
                    </div>
                    <div className="firm-hero__stat">
                        <span className="firm-meta-label">Practice areas</span>
                        <span className="firm-meta-value">{sectionCount}</span>
                    </div>
                </div>
            </section>
            <Content subsections={lawyer.subsections} />
        </main>
    );
}